(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table-components/tipsinfo-table.row.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table-components/tipsinfo-table.row.js');
"use strict";

const {
  clx
} = svs.components.lbUtils;
const {
  TableHeaderCell,
  TableContentCell
} = svs.components.tipsen.tipsinfo.tableComponents;
const TableRow = _ref => {
  let {
    children,
    className,
    dataTestId = ''
  } = _ref;
  return React.createElement("tr", {
    className: clx('tipsinfo_table__row', className),
    "data-testid": dataTestId
  }, children);
};
TableRow.HeaderCell = TableHeaderCell;
TableRow.ContentCell = TableContentCell;
setGlobal('svs.components.tipsen.tipsinfo.tableComponents.TableRow', TableRow);

 })(window);